<div class="card shadow-sm mb-0">
  <div class="card-body">
    <div class="row align-items-center">
      <div class="col-md-8">
        <div class="panel">
          <h2 class="title">My Brainstorming Worksheet</h2>
          <p>
            Write a brief description of major events or memories from your
            life. These sentences will become the basis of your stories. To
            continue, you will need to brainstorm between five and fifteen story
            ideas.
          </p>
          <form [formGroup]="brainstormForm" (ngSubmit)="onSubmit()">
            <div class="col-md-10 mb-3">
              <input
                formControlName="brainstorm"
                type="text"
                class="form-control"
                placeholder="Start a new brainstorm here."
                autocomplete="new-data"
                [ngClass]="ngClassValidate(brainstormForm, 'lastName')" />
            </div>
            <div formArrayName="inputs" class="col-md-10 mb-3">
              <div
                *ngFor="
                  let item of brainstormForm.controls.inputs.controls;
                  let i = index
                ">
                <input
                  [formControlName]="i"
                  class="form-control mb-3"
                  placeholder="Start a new brainstorm here." />
              </div>
            </div>
            <div class="form-group mb-3">
              <a
                id="add_new_brainstorm"
                (click)="addInput()"
                style="cursor: pointer; color: #07b59a"
                >Add another brainstorm</a
              >
            </div>
            <!-- <button type="submit" class="btn btn-primary">
              Continue to Step 2
            </button> -->
          </form>
        </div>
      </div>
      <div class="col-md-4">
        <div class="panel">
          <h2>Need inspiration?</h2>
          <p>
            Click on a topic below to add it to your brainstorming worksheet.
          </p>

          <div class="sample-topics">
            <div class="row">
              <!-- THIS INFORMATION WILL COME FROM BACKEND, MADE IT LIKE THAT SO I DONT REPEAT CODE  -->
              <button
                class="btn col-xs-offset-1 mb-2 text-white"
                *ngFor="let inspiration of inspirationList"
                [ngStyle]="{ 'background-color': inspiration.color }">
                {{ inspiration.value }}
              </button>
            </div>
          </div>

          <a
            class="text-center"
            style="display: block; font-size: 14px; padding: 0 0 10px 0"
            id="more-brainstorming-ideas"
            >View more ideas</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
